import { render, staticRenderFns } from "./resultsDisplay3.vue?vue&type=template&id=306b3f5c&scoped=true"
import script from "./resultsDisplay3.vue?vue&type=script&lang=js"
export * from "./resultsDisplay3.vue?vue&type=script&lang=js"
import style0 from "./resultsDisplay3.vue?vue&type=style&index=0&id=306b3f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306b3f5c",
  null
  
)

export default component.exports